"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gatesSelector = exports.isUngatedSelector = void 0;

var isUngatedSelector = function isUngatedSelector(state, gateKey) {
  var _ref = state.auth || {},
      gates = _ref.gates;

  return !!(gates && gates.indexOf(gateKey) !== -1);
};

exports.isUngatedSelector = isUngatedSelector;

var gatesSelector = function gatesSelector(state) {
  return state.auth.gates;
};

exports.gatesSelector = gatesSelector;